import React from 'react'
import Users from '../../../../components/customer/users/Users'

const AEACustomerUsers = () => {

    return <Users />
}

export default AEACustomerUsers
